<template>
  <!-- name: '用户信息设置' -->
  <div class="userInfoWrap">
    <GoBack :title="title" :nextPath="nextPath" :nextQuery="nextQuery" />
    <SelectTab
      :selectTabList="selectTabList"
      :curSelectTab="curSelectTab"
      @selectTab="selectTab"
    />
    <InfoBase v-if="curSelectTab === '个人信息'" />
    <InfoAddress v-else />
  </div>
</template>

<script>
import GoBack from "@/components/GoBack";
import SelectTab from "@/components/SelectTab";
import InfoBase from "./components/infoBase.vue";
import InfoAddress from "./components/infoAddress.vue";
export default {
  components: { GoBack, SelectTab, InfoBase, InfoAddress },
  data() {
    return {
      title: "信息设置",
      selectTabList: ["个人信息", "发货地址"],
      curSelectTab: "个人信息",
      nextPath: "/userCenter",
      nextQuery: '',
    };
  },
  created() {
    this.curSelectTab = this.$route.query.curSelectTab
      ? this.$route.query.curSelectTab
      : this.curSelectTab;
    this.nextPath = this.$route.query.nextPath
      ? this.$route.query.nextPath
      : this.nextPath;
    this.nextQuery = this.$route.query.nextQuery
      ? this.$route.query.nextQuery
      : this.nextQuery;
  },
  methods: {
    selectTab(item) {
      this.curSelectTab = item;
    },
  },
};
</script>

<style lang="scss" scoped>
.userInfoWrap {
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: #f5f5f5;
  font-family: PingFangSC, PingFang SC;
   
  .selectTabBox {
    border-top: none;
    justify-content: space-around;
     margin-top: 96px;
    ::v-deep .lineBox {
      margin-top: -6px;
    }
  }
}
</style>
